import { RelaxedRuleVo } from 'src/vo/RelaxedRule.vo';

// How: 自動配車ダイアログのチップの表示名だけを短縮する(#366 の試作)。
// Why not RelaxedRuleValues の値を変えない: 値は localStorage と API の relax_constraints に流れるため(#329 と同じ扱い)
// 「荷台高さ」「荷台長さ」は #329 で改名する前の値(relaxedRule.util.ts の RENAMED_RELAXED_RULES)と同じ文字列だが、
// ここは表示名なので復元時の値の読み替えには関わらない
const SHORT_LABELS: Partial<Record<RelaxedRuleVo, string>> = {
  荷台高: '荷台高さ',
  荷台長: '荷台長さ',
  '1回転あたりの最大納品先件数': '回転当り納品数',
  配送バンドルID: 'バンドルID',
  大型車両と荷物の割り付け条件: '大型割付条件',
};

export const relaxedRuleLabel = (rule: RelaxedRuleVo): string => SHORT_LABELS[rule] ?? rule;
